import { Dialog } from '@mui/material';

import { styledCustom } from '/styles/helpers/styledCustom';

export const StyledDialog = styledCustom(Dialog)<{ size: number }>`
  & .MuiPaper-root {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(2)};
    width: ${({ size, theme }) => `calc(${size}px + ${theme.spacing(4)})`};
    padding: ${({ theme }) => theme.spacing(2)};
    text-align: center;
  }
`;
